import { render } from "./Loseblatt.vue?vue&type=template&id=f9605a5c"
import script from "./Loseblatt.vue?vue&type=script&lang=js"
export * from "./Loseblatt.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__